import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMicrophone, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames/bind";
import styles from "../../AIChatbot.module.scss";

const cx = classNames.bind(styles);

export default function ChatFooter({
  textareaRef,
  handleInput,
  messageInput,
  setMessageInput,
  handleKeyDown,
  handleVoiceChat,
  handleSendMessage,
}) {
  return (
    <div className={cx("chat-footer", "w-100")}>
      <div className={cx("chat-textarea-container", "bg-body-emphasis")}>
        <textarea
          ref={textareaRef}
          onInput={handleInput}
          placeholder="Type message here..."
          className={cx("chat-textarea", "fs-8-1 ps-2 scrollbar")}
          value={messageInput}
          onChange={(e) => setMessageInput(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <div className="d-flex justify-content-end">
          <div className={cx("icon-action")} onClick={handleVoiceChat}>
            <FontAwesomeIcon className="fs-9" icon={faMicrophone} />
          </div>
          <div className={cx("icon-action", "me-3")} onClick={handleSendMessage}>
            <FontAwesomeIcon className="fs-9" icon={faPaperPlane} />
          </div>
        </div>
      </div>
    </div>
  );
}

